import Highcharts from 'highcharts';
import { genComponent } from 'vue-highcharts';

export default genComponent('Highcharts', Highcharts);
